import { Routes, Route } from "react-router-dom";
import { Home } from "../Components/Home.jsx";
import { Aboutus } from "../Components/Aboutus.jsx";
import { Oryza } from "../Components/Oryza.jsx";
import { Sreevanam } from "../Components/Sreevanam.jsx";
import { Aushadha } from "../Components/Aushadha.jsx";
import { Dropdown } from "../Components/Dropdown.jsx";

export const MainRoutes =()=>{
    return (
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/oryza" element={<Oryza />} />
        <Route path="/sreevanam" element={<Sreevanam />} />
        <Route path="/aushadha" element={<Aushadha />} />
        <Route path="/dropdown" element={<Dropdown />} />
      </Routes>
    );
}